import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Image from '../../../shared/components/Image';
import { IMAGE_PROPS } from '../../../shared/utils/ImageUtils';
import VerbHeading from '../../../shared/components/VerbHeading';

export default class BadgesSection extends PureComponent {
    static propTypes = {
        userBadges: PropTypes.array
    };

    render() {
        const { userBadges = [] } = this.props;
        const imageProps = IMAGE_PROPS.pathwayBadgeImageCloudinary;
        const badgesList = userBadges.map((badge) => (
            <div key={badge._id} className={'badge-image col-sm-3 col-6'}>
                <Image
                    key={badge._id}
                    src={badge.image}
                    dimension={imageProps.dimension}
                    cloudinaryCrop={IMAGE_PROPS.cloudinaryCrop}
                    radius={'max'}
                />
                <h4 className={'badge-name'}>{badge.name}</h4>
            </div>
        ));

        return (
            <div className={'badges-container col-12'}>
                <div className={'container'}>
                    <VerbHeading
                        hNumber={5}
                        defaultMessage={'YOU NOW HAVE THE FOLLOWING BADGES'}
                        messageId={'PATHWAY_BADGES'}
                    />
                    {userBadges && userBadges.length ? (
                        <div>
                            <div className={'badges-row'}>{badgesList}</div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}
